import React, { useState } from 'react'
import {
  Box, Divider,
  Grid,
  IconButton,
  ImageListItem,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material'
import styles from './styles'
import CloseIcon from '@mui/icons-material/Close'
import { SavedArticle } from '../../type/article'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { EntitlementArticle } from '../../../../../common/interfaces/EntitlementArticle'
import DeleteArticleModal from '../dialog/DeleteArticleModal'

type DrawerContentProps = {
  onClick: (open: boolean) => void
  deleteArticles: (article: EntitlementArticle[], callback: () => void) => void
  onListItemClick: (article: SavedArticle) => void
  articles: SavedArticle[]
}

const DrawerContent = (props: DrawerContentProps) => {
  const { articles, onClick, onListItemClick, deleteArticles } = props
  const [showDelete, setShowDelete] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedArticles, setSelectedArticles] = useState<SavedArticle>()

  const onEditSaveArticleClicked = () => {
    setShowDelete(!showDelete)
  }

  const handleDelete = (article: SavedArticle) => {
    setShowDeleteModal(true)
    setSelectedArticles(article)
  }

  const onConfirm = () => {
    selectedArticles && deleteArticles(selectedArticles.savedArticles, onClose)
  }

  const onClose = () => {
    setShowDeleteModal(false)
  }

  const onCancel = () => {
    setShowDeleteModal(false)
  }

  const renderDeleteSection = (article: SavedArticle) => {
    return (
      <Box style={styles.deleteContainer}>
        <Box style={styles.trash}>
          <DeleteIcon fontSize={'large'} style={{ color: 'red'}} onClick={() => handleDelete(article)}/>
          <Typography style={styles.largeText}>&nbsp;Trash</Typography>
        </Box>
        <Typography style={styles.drawerSubheader}>Delete {article.savedArticles.length} saved articles</Typography>
      </Box>
    )
  }

  return (
    <Box role="presentation">
      <DeleteArticleModal
        visible={showDeleteModal}
        onConfirm={onConfirm}
        onCancel={onCancel}
        text={selectedArticles ? `You are about to trash ${selectedArticles.savedArticles.length} saved articles` : ''}
      />
      <List>
        <IconButton onClick={() => onClick(false)} style={styles.closeIcon}>
          <CloseIcon />
        </IconButton>
        <Box sx={{ p: 1.5 }} />
        <Grid sx={styles.drawerContainer}>
          <Typography style={styles.drawerHeader}>Saved Articles</Typography>
          <Typography style={styles.drawerSubheader}>By Magazine</Typography>
        </Grid>
        <Box onClick={onEditSaveArticleClicked} style={styles.edit}>
          <EditIcon fontSize={'small'}/>
          <Typography style={styles.drawerSubheader}>&nbsp;{!showDelete ? 'Edit Saved Articles' : 'Finish Editing'}</Typography>
        </Box>
        {(articles || []).map((savedArticle: SavedArticle) => (
          <ListItem key={savedArticle.entitlementId}>
            <ListItemButton>
              <ImageListItem key={savedArticle.coverImageUrl} style={styles.bottomLine}>
                {showDelete && renderDeleteSection(savedArticle)}
                <img
                  onClick={() => onListItemClick(savedArticle)}
                  srcSet={savedArticle.coverImageUrl}
                  src={savedArticle.coverImageUrl}
                  alt={savedArticle.magTitle}
                  loading="lazy"
                />
                <ListItemText
                  disableTypography
                  primary={
                    <>
                      <Typography variant="body2" style={styles.drawerTitle}>{savedArticle.magTitle}</Typography>
                      <Typography variant="body2" style={styles.drawerSubtitle}>({savedArticle.savedArticles.length} Saved Articles)</Typography>
                      <Box sx={{ p: 1 }} />
                    </>
                  }
                />
              </ImageListItem>
              <Divider />
            </ListItemButton>
            <Divider />
          </ListItem>
        ))}
      </List>
    </Box>
  )
}

export default DrawerContent
